// extracted by mini-css-extract-plugin
export default {"header":"News_header__TMHbg","title":"News_title__eqYv-","searchBar":"News_searchBar__fO5Ei","no-data":"News_no-data__VtkSx"};